import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Upper-case the first character; empty string passes through. */
export function capitalizeFirst(value: string): string {
  return value === '' ? value : value.charAt(0).toUpperCase() + value.slice(1);
}
